module.exports = __webpack_public_path__ + "img/008.795a8baf.jpg";